import '../styles.css';
import { Game } from './game/Game.ts';

async function main() {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

  if (!canvas) {
    console.error('Canvas not found');
    return;
  }

  const game = new Game(canvas);
  await game.init();
}

main().catch(console.error);
